module.exports = __webpack_public_path__ + "img/apcs2.62761497.jpeg";